import { IKeyValueSynchronous } from 'core-ts-types';
import { Datasource } from 'utility-ts-datasource';
import { HoldType } from './../builders/holdtype_builder';

angular.module('lib').factory('ngHoldTypeDatastore', (): IKeyValueSynchronous<HoldType> => {
  return new Datasource<HoldType>({
    builderType: HoldType,
    autoId: false
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/datasources/holdtype_datasource.ts